import { Auth0Provider } from "@auth0/auth0-react";
import ReactDOM from "react-dom";
import "whatwg-fetch";
import config from "./config";
import { SessionStorageCache } from "./auth-cache";
import { AuthProvider } from "./contexts/auth-context";
import { FormContextProvider } from "./contexts/form-context";
import { ColorProvider } from "./contexts/color-context/ColorContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastProvider } from "./contexts/toast-context";
import "./styles/layout.css";

import "./index.css";
import Router from "./routes";
import * as serviceWorker from "./serviceWorker";
const configString = process.env.REACT_APP_FQS_CONFIG;
const configStrings = configString ? JSON.parse(configString) : {};

const ENV_TYPE =
  configStrings.Env === "sandbox" ? "dev" : configStrings.Env || "dev";

// const REACT_APP_AUTH0_REDIRECT_URI = "https://d1qu2whgsoksqm.cloudfront.net"
const AUTH0_CLIENT_ID = config.client_mapping || "auth0_client_id";

console.log = config.logger[ENV_TYPE];

const domain = config.domain.replace(/\/$/, "");

// Keeps the session across a page reload (see auth-cache.ts)
const authCache = new SessionStorageCache();

ReactDOM.render(
  <Auth0Provider
    domain={domain}
    clientId={AUTH0_CLIENT_ID}
    cache={authCache}
    authorizationParams={{
      redirect_uri: `${config.clientAppUrl}`,
      connection: "email",
    }}
  >
    <div id="portal-root" />
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <ColorProvider>
            <FormContextProvider>
              <Router />
            </FormContextProvider>
          </ColorProvider>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  </Auth0Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
